function initialState() {
  return {
    parentScreenKey: 0,
    show: false,
    showSheet: false,
    showDialogs: false,
    dialogs: [],
    showModal: false,
    modalWidth: null,
    modalComponent: null,
    modalComponentProps: null,
    modalCount: 0,
    showTooltip: false,
    tooltipTitle: "",
    tooltipContent: null,
    showLeftDrawer: false,
    leftDrawerComponent: false,
    leftDrawerComponentProps: null,
    activeScreenName: "",
    tourActive: false,
  };
}

const state = initialState();

const actions = {
  triggerParentScreenRefresh({ commit }) {
    commit("updateParentScreenKey");
  },
};

const mutations = {
  reset(state) {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
  updateParentScreenKey(state) {
    state.parentScreenKey += 1;
  },
  updateShow(state, value) {
    state.show = value;
  },
  updateShowSheet(state, value) {
    state.showSheet = value;
  },
  addDialog(state, value) {
    state.dialogs.push(value);
    state.showDialogs = true;
  },
  removeDialog(state, value) {
    state.dialogs = state.dialogs.filter((obj) => obj.id !== value);
    state.showDialogs = state.dialogs.length !== 0;
  },
  updateShowModal(state, value) {
    if (value) {
      state.modalCount++;
    } else {
      state.modalCount--;
    }
    state.showModal = value;
  },
  updateModalWidth(state, value) {
    state.modalWidth = value;
  },
  updateModalComponent(state, value) {
    state.modalComponent = value;
  },
  updateModalComponentProps(state, value) {
    state.modalComponentProps = value;
  },
  updateModalCount(state, value) {
    state.modalCount = value;
  },
  updateShowTooltip(state, value) {
    state.showTooltip = value;
  },
  updateTooltipTitle(state, value) {
    state.tooltipTitle = value;
  },
  updateTooltipContent(state, value) {
    state.tooltipContent = value;
  },
  updateShowLeftDrawer(state, value) {
    state.showLeftDrawer = value;
  },
  updateLeftDrawerComponent(state, value) {
    state.leftDrawerComponent = value;
  },
  updateLeftDrawerComponentProps(state, value) {
    state.leftDrawerComponentProps = value;
  },
  updateActiveScreenName(state, value) {
    state.activeScreenName = value;
  },
  updateTourActive(state, value) {
    state.tourActive = value;
  },
};

export const navigation = {
  namespaced: true,
  state,
  actions,
  mutations,
};
